import React from 'react';
import _ from 'lodash';

import List from '@mui/material/List';

import { PAGE_SIZE } from 'ff/debrief/utils';
import { useCurrentTracklog } from 'ff/debrief/hooks';
import { useGetAllSharedTracklogsQuery } from 'ff/debrief/features/TracklogApi';

import DateDivider from './DateDivider';
import ItemDivider from './ItemDivider';
import TracklogListItem from './TracklogListItem';
import EmptyListMessage from './EmptyListMessage';
import GhostItem from './GhostItem';

const SharedTracklogList = () => {
    const q = useGetAllSharedTracklogsQuery();
    const { tracklog: selectedTracklog } = useCurrentTracklog();

    const isEmptyList = q.data?.length === 0;

    if (q.isLoading) {
        return (
            <List sx={{ padding: '0 4px 4px' }}>
                {_.range(PAGE_SIZE).map(idx => (
                    <GhostItem key={idx} />
                ))}
            </List>
        );
    } else if (isEmptyList) {
        return <EmptyListMessage />;
    } else {
        const listItems: React.ReactNode[] = [];
        q.data.forEach(({ tracklogSummary: tl }, idx, arr) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let prevEntry: any;
            if (idx === 0) {
                prevEntry = null;
            } else {
                prevEntry = arr[idx - 1].tracklogSummary;
            }
            const currMonth = new Date(tl.timestampStart).getMonth();
            const prevMonth = new Date(prevEntry?.timestampStart).getMonth();
            if (currMonth !== prevMonth) {
                listItems.push(
                    <DateDivider
                        key={tl.timestampStart}
                        dateString={tl.timestampStart}
                    />
                );
            } else {
                listItems.push(<ItemDivider key={tl.trackUuid + '-div'} />);
            }
            const selected = selectedTracklog.trackUuid === tl.trackUuid;
            listItems.push(
                <TracklogListItem
                    key={tl.trackUuid}
                    selected={selected}
                    shared
                    {...tl}
                    sharedList={true}
                />
            );
        });
        return (
            <List sx={{ padding: '0 4px 4px' }} dense>
                {listItems}
            </List>
        );
    }
};

export default SharedTracklogList;
